import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "menu menu-md-rounded menu-column menu-md-row menu-state-bg menu-title-gray-700 menu-state-title-secundary menu-state-icon-secundary menu-state-bullet-secundary menu-arrow-gray-400 fw-bold my-5 my-md-0 d-md-flex align-items-stretch",
  id: "#kt_header_menu_dropdown",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-md-down-accordion me-md-1"
}
const _hoisted_4 = { class: "menu-link py-3" }
const _hoisted_5 = { class: "menu-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "arrow-drop" }, null, -1)
const _hoisted_7 = { class: "menu-sub menu-sub-md-down-accordion menu-sub-md-dropdown menu-rounded-0 py-md-4 w-md-225px" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "menu-icon indicator-progress" }
const _hoisted_11 = { class: "menu-title" }

import UseHandleExportXlsx from "@/views/cardapio/composables/handleExport";
import { onMounted, PropType } from "vue";
import { MenuComponent } from "@/assets/ts/components";
import useAlert from "@/composables/Alert";

interface MenuItem {
  id: number;
  heading: string;
  route: string | null;
  svgIcon: string;
  exportKey: string | null;
  classIcon: string;
  loading: boolean;
}

interface MenuSection {
  sectionTitle: string;
  sub: MenuItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuDropdown',
  props: {
  menu: {
    type: Array as PropType<MenuSection[]>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const { showTimeAlert } = useAlert();

onMounted(() => {
  MenuComponent.reinitialization();
});

const { handleExport } = UseHandleExportXlsx();
const prop = __props;

const exportData = async (exportKey: string | null, idMenu: number, menuName: string) => {
  if (exportKey === null) return;

  const menu = prop.menu
    .find(({ sectionTitle }) => sectionTitle === menuName)
    ?.sub.find(({ id }) => id === idMenu);

  if (!menu || menu.loading) return;

  menu.loading = true;

  try {
    showTimeAlert("Sua exportação foi iniciada, aguarde um momento.");
    await handleExport(exportKey)

  } catch (error) {
    console.error("Erro ao exportar", error);
    showTimeAlert("Error ao exportar seu arquivo",'error');
  } finally {
    menu.loading = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: prop.id,
    class: "header-menu align-items-stretch",
    "data-kt-drawer": "false",
    "data-kt-drawer-name": "header-menu-dropdown",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "end",
    "data-kt-drawer-toggle": "#kt_header_menu_dropdown_toggle",
    "data-kt-place": "true",
    "data-kt-place-mode": "prepend",
    "data-kt-place-parent": "{default: '#kt_body'}"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prop.menu, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.sectionTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.sectionTitle), 1),
                  _hoisted_6
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sub, (menuItem, j) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                      (menuItem.heading)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: ($event: any) => (exportData(menuItem.exportKey, menuItem.id, item.sectionTitle)),
                            class: "menu-item"
                          }, [
                            _createElementVNode("a", {
                              class: "menu-link py-3",
                              href: menuItem.route ? menuItem.route : 'javascript:void(0)'
                            }, [
                              _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(` ${
                        menuItem.loading
                          ? 'spinner-border spinner-border-sm align-middle ms-2'
                          : menuItem.classIcon
                      } fs-2`)
                                }, null, 2)
                              ]),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(menuItem.heading), 1)
                            ], 8, _hoisted_9)
                          ], 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ], 8, _hoisted_1))
}
}

})